import { Series } from "../../models/series";
import "./chart-series-list.style.scss"

import { ISeriesApi } from "lightweight-charts";

export class SeriesVisibilityChangedEvent extends Event {
  static EVENT_NAME = "SeriesVisibleChanged"
  constructor(type: string, public seriesIndex: number, public visible: boolean) { super(type) }
}

export class SeriesListComponent extends HTMLDivElement {
  private readonly ACTIVE_CLASSNAME = 'active'
  private _seriesButtons: HTMLElement[]

  constructor() {
    super()
    this.className = "seriesDiv"
  }

  init(seriesList: Series[]) {
    this._seriesButtons = seriesList.map(this.createSeriesButton.bind(this))
    for (let index = 0; index < this._seriesButtons.length; index++) {
      this.appendChild(this._seriesButtons[index])
    }
  }

  // private createSeriesButton(name: string, seriesAPI: ISeriesApi<any>, index: number): HTMLButtonElement {
  private createSeriesButton(series: Series, index: number): HTMLButtonElement {
    const btn: HTMLButtonElement = document.createElement('button')
    btn.innerText = series.name
    btn.classList.add(this.ACTIVE_CLASSNAME)
    btn.dataset.index = index.toString()
    btn.style.cursor = 'auto'
    // btn.style.setProperty('--before-color', seriesAPI.options().color)
    // btn.style.setProperty('--before-color', series.options().color)
    btn.style.setProperty('--before-color', series.options.color as string)
    // btn.dataset.index = index.toString()
    // btn.addEventListener('click', this.toggleVisibility.bind(this))
    return btn
  }

  private toggleVisibility(e: MouseEvent) {
    // const btn = e.target as HTMLElement
    // const series = this.getSeriesByName(btn.dataset.seriesName!)
    // const newVisibility = !this.getSeriesVisible(series)
    // this.setSeriesVisible(series, newVisibility)

    // if (newVisibility) {
    //   const allVisible = Array.from(this._seriesMap.values()).every(series => this.getSeriesVisible(series))
    //   if (allVisible) {
    //     this._seriesButtons.forEach(b => b.classList.remove('active'))
    //   } else {
    //     btn.classList.add('active')
    //   }
    // } else {
    //   const allHidden = Array.from(this._seriesMap.values()).every(series => !this.getSeriesVisible(series))
    //   if (allHidden) {
    //     this._seriesMap.forEach(series => this.setSeriesVisible(series, true))
    //   }
    //   btn.classList.remove('active')
    // }
  }

  // private getSeriesVisible(series: ISeriesApi<any>): boolean {
  //   return series.options().visible
  // }

  // private setSeriesVisible(series: ISeriesApi<any>, visible: boolean): void {
  //   series.applyOptions({ visible })
  // }

  // private getSeriesByName(seriesName: string) {
  //   // return this._seriesMap.get(seriesName)!
  // }

  // btnActive = (btn: HTMLElement): boolean => btn.classList.contains(this.ACTIVE_CLASSNAME)
}
